export default __webpack_public_path__ + "static/media/Tendencias-orange.7130d78a.svg";